import { inject, Injectable } from '@angular/core';
import { Apollo, gql, MutationResult } from 'apollo-angular';
import { GetQuery } from '../shared/types/get-query';
import { Observable } from 'rxjs';
import { ApolloQueryResult } from '@apollo/client/core';
import { MutationQuery } from '../shared/types/mutation-query.enum';
import { MutationResponse } from '../shared/types/mutation-response.type';
import { AppService } from '../app.service';

@Injectable({
	providedIn: 'root'
})
export class GraphQLService {
	readonly #apollo = inject(Apollo);
	readonly #appService = inject(AppService);

	getData<T>(query: GetQuery, variables?: any): Observable<ApolloQueryResult<T>> {
		return this.#apollo.watchQuery<T>({
			query: gql`
				${query}
			`,

			variables,
			fetchPolicy: 'no-cache'
		}).valueChanges;
	}

	postData(mutation: MutationQuery, variables?: any): Observable<MutationResult<MutationResponse>> {
		return this.#apollo.mutate({
			mutation: gql`
				${mutation}
			`,
			variables,
			fetchPolicy: 'no-cache'
		});
	}
}
